<template>
  <div class="dynamic-pagination">
    <ELoadingButton
      size="m"
      variant="outline"
      :loading="fetchingResults"
      data-test-id="dynamic-pagination-button"
      @click.prevent="onClick"
    >
      {{ $t('web.pagination.more') }}
    </ELoadingButton>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ELoadingButton from '~~/common/vue/components/loading-button';

export default {
  components: {
    ELoadingButton,
  },
  computed: {
    ...mapState({
      fetchingResults: 'fetchingResults',
      nextPage: (state) => state.pagination.nextPage,
    }),
    url() {
      const url = new URL(location.href);
      url.searchParams.set('nextPage', this.nextPage);
      return url.toString();
    },
  },
  methods: {
    onClick() {
      this.$emit('change', this.url);
    },
  },
};
</script>

<style>
.dynamic-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
